import React from "react";

export default class ChevronSteps extends React.Component {
  static defaultProps = {
    stepCount: 5,
    renderStepContent: (stepNum) => "Step " + stepNum,
    onStepClick: null,
    activeStep: 1,
  };

  constructor(props) {
    super(props);
    this.state = {
       hoverStep: null
    }
  }

  renderSteps = () => {
    const steps = [];
    let {stepCount, activeStep, onStepClick, renderStepContent} = this.props;

    for (let i = 1; i <= stepCount; i++) {
      steps.push(
        <div
          className={`
          chevron  
          
          ${(activeStep === i || this.state.hoverStep === i) ? "active" : ""}
          ${onStepClick ? 'is-clickable' : ''}
          `}
          onMouseOver={(e) => !!onStepClick && this.setState({hoverStep: i})}
          onMouseOut={(e) => !!onStepClick && this.setState({hoverStep: null})}
          onClick={(e) => !!onStepClick && onStepClick(i)}
        >
          <div className="chevron-content">
            {this.props.renderStepContent(i)}
          </div>
        </div>
      );
    }

    return steps;
  };

  render() {
    return (
      <div className="chevron-wrapper only-desktop">
        <div className="is-flex is-flex-wrap-nowrap">
          {this.renderSteps()}
        </div>
      </div>
    );
  }
}
